import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useLang } from "@/i18n";
import { Menu, X } from "lucide-react";

const LangToggle = ({ className = "" }) => {
  const { lang, setLang } = useLang();
  return (
    <div className={`flex items-center border border-forest/30 ${className}`} data-testid="lang-toggle">
      {["nl", "ru", "en"].map((l) => (
        <button
          key={l}
          data-testid={`lang-${l}`}
          onClick={() => setLang(l)}
          className={`px-3 py-1.5 text-xs font-semibold tracking-widest uppercase transition-colors ${
            lang === l ? "bg-forest text-white" : "text-forest hover:bg-forest/10"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
};

export default function Header() {
  const { t } = useLang();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-bone/70 border-b border-forest/10" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <Link to="/" className="font-serif text-xl md:text-2xl tracking-tight text-forest" data-testid="logo-link">
          Learn&nbsp;with&nbsp;Devid
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          <Link
            to="/"
            data-testid="nav-home"
            className={`text-sm font-semibold tracking-wide transition-colors ${
              pathname === "/" ? "text-terracotta" : "text-ink hover:text-forest"
            }`}
          >
            {t.nav.home}
          </Link>
          <a href="/#contact" data-testid="nav-contact" className="text-sm font-semibold tracking-wide text-ink hover:text-forest">
            {t.nav.contact}
          </a>
          <Link
            to="/reviews"
            data-testid="nav-reviews"
            className={`text-sm font-semibold tracking-wide transition-colors ${
              pathname === "/reviews" ? "text-terracotta" : "text-ink hover:text-forest"
            }`}
          >
            {t.nav.reviews}
          </Link>
          <LangToggle />
        </nav>

        <button className="md:hidden text-forest" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-forest/10 bg-bone px-6 py-6 flex flex-col gap-5" data-testid="mobile-menu">
          <Link to="/" onClick={() => setOpen(false)} className="text-base font-semibold text-ink">
            {t.nav.home}
          </Link>
          <a href="/#contact" onClick={() => setOpen(false)} className="text-base font-semibold text-ink">
            {t.nav.contact}
          </a>
          <Link to="/reviews" onClick={() => setOpen(false)} className="text-base font-semibold text-ink">
            {t.nav.reviews}
          </Link>
          <LangToggle className="w-fit" />
        </div>
      )}
    </header>
  );
}
